module.exports = __webpack_public_path__ + "static/media/WEO76LIS0001.87dc8323.svg";